import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { tokens } from "../../../theme";

const KPICard = ({ label, value, deltaPct, trend }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isPositive = deltaPct >= 0;
    const isNeutral = deltaPct === 0;

    return (
        <Paper 
            sx={{ 
                p: 2, 
                display: 'flex', 
                flexDirection: 'column', 
                height: '100%',
                bgcolor: colors.primary[400],
                borderRadius: '8px',
                border: `1px solid ${colors.grey[800]}`
            }}
            elevation={0}
        >
            <Typography variant="subtitle2" color={colors.grey[300]}>
                {label}
            </Typography>
            <Box mt="auto" display="flex" alignItems="baseline" justifyContent="space-between">
                <Typography variant="h4" fontWeight="bold" color={colors.grey[100]}>
                    {value}
                </Typography>
                
                <Box display="flex" alignItems="center" color={isPositive ? colors.greenAccent[500] : colors.redAccent[500]}>
                    {isPositive ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />}
                    <Typography variant="caption" fontWeight="bold">
                        {Math.abs(deltaPct)}%
                    </Typography>
                </Box>
            </Box>
        </Paper>
    );
};

const KPIGrid = ({ kpis }) => {
    return (
        <Box 
            display="grid" 
            gridTemplateColumns="repeat(auto-fit, minmax(200px, 1fr))" 
            gap={2} 
            mb={3}
        >
            {kpis.map((kpi, idx) => (
                <KPICard key={idx} {...kpi} />
            ))}
        </Box>
    );
};

export default KPIGrid;
